import { Mtds } from '..'
import { i18n } from '../i18n'
import { toUserMessage, type UserErrorLocale } from '../utils/userErrorUtils'

/**
 * Returns a `(error) => void` handler that shows a user-facing toast and logs
 * the raw error for diagnostics.
 *
 * Expected validation errors keep their actionable server message; unexpected
 * service/network failures get friendly Norwegian/English copy (following the
 * active i18n language, e.g. English in provelab). The raw error is retained
 * via `console.error` so nothing is lost to logging.
 *
 * @param action Norwegian/English nominal phrase describing the operation that
 *               failed, e.g. `'lagre hensikten'`.
 */
export const useErrorToast = (action?: string) => {
  return (error: unknown) => {
    const locale: UserErrorLocale = i18n.language === 'en' ? 'en' : 'nb'
    console.error(error)
    Mtds.toast.danger(toUserMessage(error, action, { locale }))
  }
}
